// extracted by mini-css-extract-plugin
export default {"form":"AddBlog_form__d3+RS","author-info":"AddBlog_author-info__IssAT"};